export enum Side {
	LEFT = 'left',
	RIGHT = 'right',
}
